// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View_wrapper__3GLsI","buttonEnd":"View_buttonEnd__Cbxw9","mr":"View_mr__31wap","redButton":"View_redButton__fr6Gv"};